import React from "react";
import { Container, Grid, Typography, Box } from "@mui/material";

import Logo from "./Header/Logo";

function FooterText(text) {
  return (
    <Typography variant="body2" color="textSecondary">
      {text}
    </Typography>
  );
}

const copyright = `Copyright © Good Blocks ${new Date().getFullYear()}.`;

export default function Footer() {
  return (
    <Box
      sx={{
        marginTop: "auto",
        p: "2rem 0 2rem 0",
        backgroundColor: "grey.light",
        width: "100%",
      }}
    >
      <Container maxWidth="xl" sx={{ textAlign: "left" }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Logo />
          </Grid>
          <Grid item xs={2}>
            {FooterText("Products")}
          </Grid>
          <Grid item xs={2}>
            {FooterText("Cookie settings")}
          </Grid>
          <Grid item xs={2}>
            {FooterText("Socials")}
          </Grid>
          <Grid item xs={2}>
            {FooterText(copyright)}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
